"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeActiveParticipants = exports.SubscribeParticipantLeft = exports.SubscribeParticipantJoined = exports.SubscribeConferenceEnded = exports.SubscribeConferenceCreated = exports.SubscribeInvitation = exports.SubscriptionType = void 0;
/**
 * The SubscriptionType model gathers the subscription types.
 */
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["Invitation"] = "Invitation";
    SubscriptionType["ConferenceCreated"] = "Conference.Created";
    SubscriptionType["ConferenceEnded"] = "Conference.Ended";
    SubscriptionType["ParticipantJoined"] = "Participant.Joined";
    SubscriptionType["ParticipantLeft"] = "Participant.Left";
    SubscriptionType["ConferenceActiveParticipants"] = "Conference.ActiveParticipants";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
/**
 * The SubscribeInvitation model includes the [Invitation] subscription type that can be included the the [subscribe](doc:js-client-sdk-notificationservice#subscribe) method.This subscription is enabled by default.
 */
class SubscribeInvitation {
    constructor() {
        /** The subscription type. */
        this.type = SubscriptionType.Invitation;
    }
}
exports.SubscribeInvitation = SubscribeInvitation;
/**
 * The SubscribeConferenceCreated model includes the conference [alias](#conferencealias) and the [ConferenceCreated](#type) subscription type that can be included in the [subscribe](doc:js-client-sdk-notificationservice#subscribe) method.
 */
class SubscribeConferenceCreated {
    /** @ignore */
    constructor(conferenceAlias) {
        /** The subscription type. */
        this.type = SubscriptionType.ConferenceCreated;
        this.conferenceAlias = conferenceAlias;
    }
}
exports.SubscribeConferenceCreated = SubscribeConferenceCreated;
/**
 * The SubscribeConferenceEnded model includes the conference [alias](#conferencealias) and the [ConferenceEnded](#type) subscription type that can be included the the [subscribe](doc:js-client-sdk-notificationservice#subscribe) method.
 */
class SubscribeConferenceEnded {
    /** @ignore */
    constructor(conferenceAlias) {
        /** The subscription type. */
        this.type = SubscriptionType.ConferenceEnded;
        this.conferenceAlias = conferenceAlias;
    }
}
exports.SubscribeConferenceEnded = SubscribeConferenceEnded;
/**
 * The SubscribeParticipantJoined model includes the conference [alias](#conferencealias) and the [ParticipantJoined](#type) subscription type that can be included the the [subscribe](doc:js-client-sdk-notificationservice#subscribe) method.
 */
class SubscribeParticipantJoined {
    /** @ignore */
    constructor(conferenceAlias) {
        /** The subscription type. */
        this.type = SubscriptionType.ParticipantJoined;
        this.conferenceAlias = conferenceAlias;
    }
}
exports.SubscribeParticipantJoined = SubscribeParticipantJoined;
/**
 * The SubscribeParticipantLeft model includes the conference [alias](#conferencealias) and the [ParticipantLeft](#type) subscription type that can be included the the [subscribe](doc:js-client-sdk-notificationservice#subscribe) method.
 */
class SubscribeParticipantLeft {
    /** @ignore */
    constructor(conferenceAlias) {
        /** The subscription type. */
        this.type = SubscriptionType.ParticipantLeft;
        this.conferenceAlias = conferenceAlias;
    }
}
exports.SubscribeParticipantLeft = SubscribeParticipantLeft;
/**
 * The SubscribeActiveParticipants model includes the conference [alias](#conferencealias) and the [ConferenceActiveParticipants](#type) subscription type that can be included the the [subscribe](doc:js-client-sdk-notificationservice#subscribe) method.
 */
class SubscribeActiveParticipants {
    /** @ignore */
    constructor(conferenceAlias) {
        /** The subscription type. */
        this.type = SubscriptionType.ConferenceActiveParticipants;
        this.conferenceAlias = conferenceAlias;
    }
}
exports.SubscribeActiveParticipants = SubscribeActiveParticipants;
